const footer = {
  brand: {
    description:
      "Премиум дентални услуги в София, България. Съчетаваме модерни технологии с персонализирано лечение, за да ви осигурим перфектната усмивка, която заслужавате.",
  },
  quickLinks: {
    title: "Бързи Връзки",
    home: "Начало",
    about: "За Нас",
    services: "Услуги",
    testimonials: "Доволни Пациенти",
    gallery: "Галерия",
    contact: "Контакти",
  },
  services: {
    title: "Нашите Услуги",
    list: {
      implantology: "Имплантология",
      endodontics: "Ендодонтия",
      "oral-surgery": "Орална Хирургия",
      periodontology: "Пародонтология",
      orthodontics: "Ортодонтия",
      prosthetics: "Протетика",
    },
  },
  questions: {
    title: "Имате Въпроси?",
    description:
      "Ние сме тук, за да помогнем! Свържете се с нас за всякакви въпроси относно нашите дентални услуги или за да запишете час.",
    buttonLabel: "Свържете се с Нас",
  },
  bottom: {
    copyright: "© {{year}} Elite Dental Solutions. Всички права запазени.",
  },
  legal: {
    privacyPolicy: "Политика за Поверителност",
    termsOfService: "Общи Условия",
  },
};

export default footer;
